<template>
  <div class="box">
    <swiper :options="swiperOption" v-if="clientWidth > 768" ref="mySwiper" :auto-play="true" class="modulelist6_box download_box">
      <div v-if="clientWidth > 768" class="swiper-button-prev swiper-button2" slot="button-prev"></div>
      <div v-if="clientWidth > 768" class="swiper-button-next swiper-button2" slot="button-next"></div>
      <swiper-slide v-for="(item, index) in list_pc" :key="index" class="modulelist6">
        <div class="modulelist6_children" v-for="(val, index) in item.children" :key="index">
          <div class="modulelist6_content">
            <div class="modulelist6_left">
              <span>{{ val.title }}</span>
              <div class="line6"></div>
              <span v-html="val.content" :class="tab ? 'modulelist6_left_span' : ''" :title="val.content"></span>
            </div>
            <div class="modulelist6_right">
              <div @click="handleDown(val)" v-if="tab">
                <span>获取客户案例</span>
                <img src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_download.png" alt=""/>
              </div>
              <div @click="handleDown(val)" v-else>
                <span>获取行业解决方案</span>
                <img src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_download.png" alt="" />
              </div>
            </div>
          </div>
          <div class="modulelist6_img">
            <img :src="'https://staticdn.ht-s.cn/se/ciif/2023/downloadCenter/' + val.img" alt="" />
          </div>
        </div>
      </swiper-slide>
      <!-- 指示点 -->
      <div class="swiper-pagination fx2" slot="pagination"></div>
    </swiper>
    <swiper :options="swiperOption_m" v-else ref="mySwiper" :auto-play="true" class="modulelist6_box download_box">
      <div v-if="clientWidth < 768" class="swiper-button-prev swiper-button2" slot="button-prev"></div>
      <div v-if="clientWidth < 768" class="swiper-button-next swiper-button2" slot="button-next"></div>
      <swiper-slide v-for="(item, index) in list_m" :key="index" class="modulelist6" >
        <div class="modulelist6_children" v-if="!tab">
          <div class="modulelist6_img">
            <img :src="'https://staticdn.ht-s.cn/se/ciif/2023/downloadCenter/' + item.children[0].img_m" alt="" />
          </div>
          <div class="modulelist6_content">
            <div class="modulelist6_left">
              <span>{{ item.children[0].title }}</span>
              <div class="line6"></div>
              <span v-html="item.children[0].content.replaceAll('\n', '<br>')" :title="item.children[0].content.replaceAll('\n', '<br>')" ></span>
            </div>
            <div class="modulelist6_right">
              <div @click="handleDown(item.children[0])">
                <span>获取行业解决方案</span>
                <img src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_download.png" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div v-else class="modulelist6_children_box">
          <div class="modulelist6_children" v-for="(val, vindex) in item.children" :key="vindex" >
            <div class="modulelist6_img">
              <img :src="'https://staticdn.ht-s.cn/se/ciif/2023/downloadCenter/' + val.img_m" alt="" />
            </div>
            <div class="modulelist6_content">
              <div class="modulelist6_left">
                <span>{{ val.title }}</span>
                <div class="line6"></div>
                <span v-html="val.content.replaceAll('\n', '<br>')" :title="item.children[0].content.replaceAll('\n', '<br>')" :class="tab ? 'modulelist6_left_span' : ''"  ></span>
              </div>
              <div class="modulelist6_right">
                <div @click="handleDown(val)">
                  <span>获取客户案例</span>
                  <img src="https://staticdn.ht-s.cn/se/ciif/2022/index/icon_download.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="intronumber">
      <div class="left"></div>
      <span v-if="clientWidth > 768" >{{ currentIndex }}/{{ list_pc.length }}</span>
      <span v-if="clientWidth <= 768" >{{ currentIndex_m }}/{{ list_m.length }}</span>
      <div class="right"></div>
    </div>
    <Rdialog
      :articleName="articleName"
      :isRegister="isRegister"
      :isEmail="isEmail"
      :isIntegral="isIntegral"
      @handleClose="handleClose"
      @handleEmail="handleEmail"
      :integralText="integralText"
    ></Rdialog>
  </div>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);

import Rdialog from "@/components/rdialog/index.vue";
import { AddPoints } from "../../api/index.js";

export default {
  props: {
    data: {
      type: Object,
      value: {},
    },
    tab: {
      type: Boolean,
      value: false,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
    Rdialog,
  },
  mounted() {
    this.currentData = this.data.industry;
  },
  data() {
    const that = this;
    return {
      active: 1,
      // list_pc: [],
      currentData: [],
      isRegister: false,
      isEmail: false,
      currentIndex: 1,
      currentIndex_m: 1,
      swiperOption: {
        // initialSlide: 0, //第几个开始播放
        slidesPerView: 1, // 一行显示3个
        // slidesPerGroup: 3,
        // freeMode: true,
        // slidesPerView: 'auto',
        speed: 1000, // 滑动速度
        effect: "flip",
        // loop: true,
        spaceBetween: 40,
        // autoplay: {
        //   delay: 4000,
        //   stopOnLastSlide: false,
        //   disableOnInteraction: false,
        // },
        // loopedSlides: 8,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: (swiper) => {
            that.currentIndex = swiper.realIndex + 1;
          },
        },
      },
      swiperOption_m: {
        direction: "horizontal",
        autoplay: {
          delay: 500000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // loop: true,
        // slidesPerView: 1.25,
        centeredSlides: true,
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          slideChange: (swiper) => {
            that.currentIndex_m = swiper.realIndex + 1;
          },
        },
      },
      articleName: "",
      isIntegral: false,
      integralText: "",
    };
  },
  methods: {
    handleDown(item) {
      let obj;
      if (this.tab) {
        obj = { event: "trk", ec: "download", ea: "storyssolutions", el: "solutions",  };
      } else {
        obj = { event: "trk", ec: "download", ea: "insightssolutions",  el: "solutions", };
      }
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      if (this.$store.state.islogin) {
        this.articleName = item.code;
        this.sendSuccess = false;
        this.isEmail = true;
      } else {
        this.isRegister = true;
      }
    },
    handleEmail(e) {
      AddPoints({
        visitType: this.active === 1 ? 23 : 13,
        track: this.$route.query.track ? this.$route.query.track : "",
        name: this.articleName,
        email: e,
      }).then((res) => {
        if (res.Status === 1) {
          this.isEmail = false;
          this.isIntegral = true;
          if (res.Data === "1") {
            this.integralText = res.Message;
          } else {
            this.integralText = "恭喜您，下载成功";
          }
        }
      });
    },
    handleClose() {
      this.isEmail = false;
      this.isRegister = false;
      this.isIntegral = false;
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    list_m() {
      let arr = [];
      if (this.tab && this.clientWidth < 768) {
        let i = Math.ceil(this.currentData.length / 2);
        for (let ind = 0; ind < i; ind++) {
          arr.push({
            children: [],
          });
        }

        let index = 0;
        this.currentData.map((sub, subIndex) => {
          arr[index].children.push(sub);
          if (arr[index].children.length >= 2) {
            index += 1;
          }
        });
      } else {
        let i = Math.ceil(this.currentData.length / 1);
        for (let ind = 0; ind < i; ind++) {
          arr.push({
            children: [],
          });
        }

        let index = 0;
        this.currentData.map((sub, subIndex) => {
          arr[index].children.push(sub);
          if (arr[index].children.length >= 1) {
            index += 1;
          }
        });
      }
      return arr;
    },
    list_pc() {
      let arr = [];
      if (this.tab && this.clientWidth > 768) {
        let i = Math.ceil(this.currentData.length / 6);
        for (let ind = 0; ind < i; ind++) {
          arr.push({
            children: [],
          });
        }

        let index = 0;
        this.currentData.map((sub, subIndex) => {
          arr[index].children.push(sub);
          if (arr[index].children.length >= 6) {
            index += 1;
          }
        });
      } else {
        let i = Math.ceil(this.currentData.length / 4);
        for (let ind = 0; ind < i; ind++) {
          arr.push({
            children: [],
          });
        }

        let index = 0;
        this.currentData.map((sub, subIndex) => {
          arr[index].children.push(sub);
          if (arr[index].children.length >= 4) {
            index += 1;
          }
        });
      }

      let eles;
      if (arr.length === 1 && arr) {
        eles = document.querySelectorAll(".swiper-button2");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "none";
          }
        }
      } else if (arr.length > 1) {
        eles = document.querySelectorAll(".swiper-button2");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "flex";
          }
        }
      }
      return arr;
    },
  },
  watch: {
    tab() {
      document.querySelector(".download_box").style.opacity = 0;
      setTimeout(() => {
        document.querySelector(".download_box").style.opacity = 1;
      }, 100);
      // this.list_pc = []
      // this.list_m = []
      document.querySelector(".download_box").classList.remove("lowBox");
      if (this.tab) {
        this.currentData = this.data.customer;
        if (this.clientWidth > 768) {
          document.querySelector(".download_box").classList.add("lowBox");
        }
        this.active = 2;
      } else {
        this.currentData = this.data.industry;
        this.active = 1;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>